import { render } from "./Employees.vue?vue&type=template&id=9bd22684&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"

import "./Employees.vue?vue&type=style&index=0&id=9bd22684&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd22684"]])

export default __exports__